module.exports = __webpack_public_path__ + "img/qing.5115380c.png";